import orderTranslationsHelper from "../../../../languages/order-translations.helper";
import {
  CandidatureAddByOrderIdNotAcceptableResponseCandidateDoesNotFitError,
  CandidatureAddByOrderIdNotAcceptableResponseCandidateFitsWithNotEnoughTimeError,
  CollisionSubjectDirectionResponse,
} from "../../../api/raily/candidature/add-by-order-id/candidature-add-by-order-id.response";
import {
  CandidatureAddByOrderIdDriverHasCandidatureError,
  CandidatureAddByOrderIdCandidateFitsWithNotEnoughTimeError,
  CandidatureAddByOrderIdErrorType,
  CandidatureAddByOrderIdCandidatureDoesNotFitError,
  CandidatureAddByOrderIdCollisionSubjectDirection,
  CandidatureAddByOrderIdEntryCandidateCollisionError,
  CandidatureAddByOrderIdOrderInProgressError,
  CandidatureAddByOrderIdOrderNotExistsError,
  CandidatureAddByOrderIdPlanEntryCandidateStartTimeExpiredError,
  CandidatureAddByOrderIdSolvedOrderCandidateStartTimeExpiredError,
  CandidatureAddByOrderIdTaxiDriverAssociationNotExistsError,
  CandidatureAddByOrderIdTaxiDriverContractNotValidError,
  CandidatureAddByOrderIdTaxiRailyContractNotExistsError,
} from "./candidature-add-by-order-id-error";

const createDriverHasCandidatureError =
  (): CandidatureAddByOrderIdDriverHasCandidatureError => {
    const translations =
      orderTranslationsHelper.getDetailsTranslations().manageDriverAssignment
        .apiErrors;

    return {
      message: translations.driverHasCandidatureErrorLabel,
      params: {},
      type: CandidatureAddByOrderIdErrorType.DRIVER_HAS_CANDIDATURE,
    };
  };

const createPlanEntryCandidateCollisionError =
  (): CandidatureAddByOrderIdEntryCandidateCollisionError => {
    const translations =
      orderTranslationsHelper.getDetailsTranslations().manageDriverAssignment
        .apiErrors;

    return {
      message: translations.planEntryCandidateCollisionErrorLabel,
      params: {},
      type: CandidatureAddByOrderIdErrorType.PLAN_ENTRY_CANDIDATE_COLLISION,
    };
  };

const createTaxiDriverAssociationNotExistsError =
  (): CandidatureAddByOrderIdTaxiDriverAssociationNotExistsError => {
    const translations =
      orderTranslationsHelper.getDetailsTranslations().manageDriverAssignment
        .apiErrors;

    return {
      message: translations.taxiDriverAssociationNotExistsErrorLabel,
      params: {},
      type: CandidatureAddByOrderIdErrorType.TAXI_DRIVER_ASSOCIATION_NOT_EXISTS,
    };
  };

const createOrderNotExistsError =
  (): CandidatureAddByOrderIdOrderNotExistsError => {
    const translations =
      orderTranslationsHelper.getDetailsTranslations().manageDriverAssignment
        .apiErrors;

    return {
      message: translations.orderNotExistsErrorLabel,
      params: {},
      type: CandidatureAddByOrderIdErrorType.ORDER_NOT_EXISTS,
    };
  };

const createOrderInProgressError =
  (): CandidatureAddByOrderIdOrderInProgressError => {
    const translations =
      orderTranslationsHelper.getDetailsTranslations().manageDriverAssignment
        .apiErrors;

    return {
      message: translations.orderInProgressErrorLabel,
      params: {},
      type: CandidatureAddByOrderIdErrorType.ORDER_IN_PROGRESS,
    };
  };

const createTaxiDriverContractNotValidError =
  (): CandidatureAddByOrderIdTaxiDriverContractNotValidError => {
    const translations =
      orderTranslationsHelper.getDetailsTranslations().manageDriverAssignment
        .apiErrors;

    return {
      message: translations.taxiDriverContractNotValidErrorLabel,
      params: {},
      type: CandidatureAddByOrderIdErrorType.TAXI_DRIVER_CONTRACT_NOT_VALID,
    };
  };

const createTaxiRailyContractNotValidError =
  (): CandidatureAddByOrderIdTaxiRailyContractNotExistsError => {
    const translations =
      orderTranslationsHelper.getDetailsTranslations().manageDriverAssignment
        .apiErrors;

    return {
      message: translations.taxiRailyContractNotValidErrorLabel,
      params: {},
      type: CandidatureAddByOrderIdErrorType.TAXI_RAILY_CONTRACT_NOT_VALID,
    };
  };

const createPlanEntryCandidateStartTimeExpiredError =
  (): CandidatureAddByOrderIdPlanEntryCandidateStartTimeExpiredError => {
    const translations =
      orderTranslationsHelper.getDetailsTranslations().manageDriverAssignment
        .apiErrors;

    return {
      message: translations.planEntryCandidateStartTimeExpiredError,
      params: {},
      type: CandidatureAddByOrderIdErrorType.PLAN_ENTRY_CANDIDATE_START_TIME_EXPIRED_ERROR,
    };
  };

const createSolvedOrderCandidateStartTimeExpiredError =
  (): CandidatureAddByOrderIdSolvedOrderCandidateStartTimeExpiredError => {
    const translations =
      orderTranslationsHelper.getDetailsTranslations().manageDriverAssignment
        .apiErrors;

    return {
      message: translations.solvedOrderCandidateStartTimeExpiredError,
      params: {},
      type: CandidatureAddByOrderIdErrorType.SOLVED_ORDER_CANDIDATE_START_TIME_EXPIRED_ERROR,
    };
  };

const createCollisionDirection = (
  direction: CollisionSubjectDirectionResponse,
): CandidatureAddByOrderIdCollisionSubjectDirection => {
  switch (direction) {
    case CollisionSubjectDirectionResponse.NEXT:
      return CandidatureAddByOrderIdCollisionSubjectDirection.NEXT;
    case CollisionSubjectDirectionResponse.PREVIOUS:
      return CandidatureAddByOrderIdCollisionSubjectDirection.PREVIOUS;
  }
};

const createPlanCandidateFitsWithNotEnoughTimeError = (
  response: CandidatureAddByOrderIdNotAcceptableResponseCandidateFitsWithNotEnoughTimeError,
): CandidatureAddByOrderIdCandidateFitsWithNotEnoughTimeError => {
  const translations =
    orderTranslationsHelper.getDetailsTranslations().manageDriverAssignment
      .apiErrors;

  return {
    message: translations.planEntryCandidateFitsWithNotEnoughTimeError,
    params: {
      collisionDirection: createCollisionDirection(
        response.collisionSubject.collisionDirection,
      ),
      existingGap: response.collisionInfo.existingGap,
      requiredGap: response.collisionInfo.requiredGap,
    },
    type: CandidatureAddByOrderIdErrorType.CANDIDATE_FITS_WITH_NOT_ENOUGH_TIME,
  };
};

const createPlanCandidateDoesNotFitError = (
  response: CandidatureAddByOrderIdNotAcceptableResponseCandidateDoesNotFitError,
): CandidatureAddByOrderIdCandidatureDoesNotFitError => {
  const translations =
    orderTranslationsHelper.getDetailsTranslations().manageDriverAssignment
      .apiErrors;

  return {
    message: translations.planEntryCandidateDoesNotFitError,
    params: {
      collisionDirection: createCollisionDirection(
        response.collisionSubject.collisionDirection,
      ),
      existingGap: response.collisionInfo.existingGap,
      requiredGap: response.collisionInfo.requiredGap,
    },
    type: CandidatureAddByOrderIdErrorType.CANDIDATE_DOES_NOT_FIT,
  };
};

const candidatureAddByOrderIdPreviewErrorFactory = {
  createDriverHasCandidatureError,
  createPlanEntryCandidateCollisionError,
  createTaxiDriverAssociationNotExistsError,
  createOrderNotExistsError,
  createOrderInProgressError,
  createTaxiDriverContractNotValidError,
  createTaxiRailyContractNotValidError,
  createPlanEntryCandidateStartTimeExpiredError,
  createPlanCandidateFitsWithNotEnoughTimeError,
  createPlanCandidateDoesNotFitError,
  createSolvedOrderCandidateStartTimeExpiredError,
};

export default candidatureAddByOrderIdPreviewErrorFactory;
